import groq from 'groq';

import { type Article } from '../../types/cmsTypes';
import { STORIES_TAG_ID } from '../../utils/tags';

export const CATEGORY_HAS_ARTICLES_PROJECTION_FIELD = groq`"hasArticles": count(*[_type == "article" && references(^._id)]) > 0`;
export const CATEGORY_LANDING_PAGE_SLUGS_GROQ = groq`*[_type == "category" && defined(slug.current)] {
  slug,
  "categoryId": _id,
  "goalId": goal->_id,
  ${CATEGORY_HAS_ARTICLES_PROJECTION_FIELD},
}[hasArticles]`;

export const CATEGORY_QUERY = groq`*[_type == "category" && lower(slug.current) == lower($categorySlug)] {
  "categoryId": _id,
  title,
  "subtitle": description,
  "goalId": goal->_id,
  slug,
}[0]`;

export type ArticleWithWrittenAt = Article & { writtenAt: string };
export const ARTICLE_WRITTEN_AT_PROJECTION_FIELD = groq`"writtenAt": coalesce(select(preferPublishedAt => firstPublishedAt, lastModifiedAt), lastModifiedAt)`;

export const BASE_ARTICLES_QUERY_FILTERS = groq`_type == "article" && !coachAudience && !noIndex && firstPublishedAt < now()`;
export const CATEGORY_BASE_ARTICLES_QUERY_FILTERS = groq`
  ${BASE_ARTICLES_QUERY_FILTERS} &&
  (references($categoryId) || references($goalId))
`;

export const STORIES_BASE_ARTICLES_QUERY_FILTERS: string = groq`${BASE_ARTICLES_QUERY_FILTERS} && references("${STORIES_TAG_ID}")`;
export const TAG_BASE_ARTICLES_QUERY_FILTERS: string = groq`${BASE_ARTICLES_QUERY_FILTERS} && references($categoryId) && references($tagId)`;
